import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import classnames from 'classnames';
import { Heading } from '@grandvisionhq/elements';
import { Spinner } from '@grandvisionhq/iris-ui';
import { useIntl } from '@grandvisionhq/state';
import AppointmentOverviewContainer from '../../../../components/AppointmentOverview/AppointmentOverviewContainer.js';
import { CancelAppointmentForm } from './CancelAppointmentForm.js';

const CancelAppointment = (_param)=>{
    var { className , appointment , labels , store , hasError , isAppointmentLoading , returnPath , isStoreLoading , disableCancelAppointmentButton , isCancellationInProgress , onSubmit  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "className",
        "appointment",
        "labels",
        "store",
        "hasError",
        "isAppointmentLoading",
        "returnPath",
        "isStoreLoading",
        "disableCancelAppointmentButton",
        "isCancellationInProgress",
        "onSubmit"
    ]);
    const { getLabel  } = useIntl();
    if (isAppointmentLoading) {
        return /*#__PURE__*/ React.createElement("div", {
            className: "cancel-appointment__loader-wrapper"
        }, /*#__PURE__*/ React.createElement(Spinner, {
            "aria-label": getLabel('common.loadingText')
        }));
    }
    if (!appointment) {
        return null;
    }
    return /*#__PURE__*/ React.createElement("div", swcHelpers.extends({}, rest, {
        className: classnames('cancel-appointment', className)
    }), /*#__PURE__*/ React.createElement(Heading, {
        component: "h3",
        variant: "smallest",
        className: "cancel-appointment--border-bottom"
    }, labels.title), /*#__PURE__*/ React.createElement(Heading, {
        variant: "smallest"
    }, labels.subtitle), /*#__PURE__*/ React.createElement(AppointmentOverviewContainer, {
        className: "cancel-appointment__overview",
        appointment: appointment,
        store: store,
        isStoreLoading: isStoreLoading
    }), /*#__PURE__*/ React.createElement(Heading, {
        component: "h3",
        variant: "smallest",
        className: "cancel-appointment--border-bottom"
    }, labels.reason), /*#__PURE__*/ React.createElement(CancelAppointmentForm, {
        labels: labels,
        hasError: hasError,
        returnPath: returnPath,
        disableCancelAppointmentButton: disableCancelAppointmentButton,
        onSubmit: onSubmit,
        isCancellationInProgress: isCancellationInProgress
    }));
};

export { CancelAppointment as default };
//# sourceMappingURL=CancelAppointment.js.map
